export default "__VITE_ASSET__CxzXWbZU__"